<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <template>
      <v-card>
        <v-toolbar dark color="teal">
          Add position to this election
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDialog">
            <v-icon>mdi-close-circle</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-form
            class="mt-5"
            v-model="addStudentFormValid"
            @submit.prevent="addPosition"
          >
            <v-combobox
              outlined
              v-model="description"
              label="Description *"
              prepend-inner-icon="mdi-blur-radial"
              :items="availablePositions"
              hide-details
              clearable
            ></v-combobox>

            <v-card-actions class="mt-2 mx-0 grey lighten-4">
              <v-btn color="red darken-2" outlined small @click="show = !show">
                Restrictions
              </v-btn>

              <v-spacer></v-spacer>

              <v-btn icon @click="show = !show">
                <v-icon>{{
                  show ? "mdi-chevron-up" : "mdi-chevron-down"
                }}</v-icon>
              </v-btn>
            </v-card-actions>

            <v-expand-transition>
              <div v-show="show" class="grey lighten-4">
                <v-divider></v-divider>

                <v-card-text>
                  <restrict-voters @restrictions="mergeRestrictions">
                  </restrict-voters>
                </v-card-text>
              </div>
            </v-expand-transition>

            <v-btn
              large
              :loading="adding"
              :disabled="adding"
              class="mt-3"
              type="submit"
              color="teal"
              outlined
            >
              Add Position
              <template v-slot:loader>
                <span>Adding...</span>
              </template>
            </v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
import RestrictVoters from "./partials/RestrictVoters.vue";

export default {
  components: { RestrictVoters },

  data: () => ({
    dialog: false,
    adding: false,
    addStudentFormValid: false,
    election: null,
    description: null,
    availablePositions: [],
    restrictions: {},

    show: false,
  }),

  methods: {
    openForm(election) {
      this.election = election;
      this.dialog = true;
    },
    closeDialog() {
      this.found = false;
      this.dialog = false;
      this.description = "";
    },
    mergeRestrictions(restrictions) {
      this.restrictions = { ...this.restrictions, ...restrictions };
      this.show = false;
    },
    addPosition() {
      if (this.description) {
        this.adding = true;

        this.$axios({
          url: "/positions",
          method: "POST",
          data: {
            ...{
              election_id: this.election,
              description: String(this.description).toUpperCase(),
            },
            ...this.restrictions,
          },
        })
          .then(() => {
            this.$bus.$emit("election.updated");
            this.closeDialog();
          })
          .catch((error) => {
            if (error.response.status == 409) {
              this.$bus.$emit("snackbar", {
                type: "warning",
                message: "Position already exist",
              });
            } else {
              this.$bus.$emit("snackbar", {
                type: "error",
                message: "Could not add position",
              });
            }
          })
          .finally(() => {
            this.adding = false;
          });
      }
    },
    fetchAvailablePositions() {
      this.$axios
        .get("/positions-available")
        .then(({ data: available }) => {
          this.availablePositions = available;
        })
        .finally(() => {
          this.finding = false;
        });
    },
  },

  mounted() {
    this.fetchAvailablePositions();
    this.$bus.$on("position.add", this.openForm);
  },
};
</script>

<style lang="scss" scoped>
.table {
  width: 100%;
  border-collapse: collapse;

  thead {
    tr {
      th {
        text-transform: uppercase;
      }
    }
  }

  tr {
    border-left: 5px solid #c3e7cd;
    border-left: 5px solid #eee1ad;
    border-bottom: thin solid #dddddd;
  }

  tr:nth-of-type(even) {
    background-color: #f3f3f3;
  }

  tr {
    th,
    td {
      padding: 0.75em 1em;
      margin: 0;
    }

    th {
      text-align: left;
    }

    td:nth-child(2) {
      font-weight: 500;
      text-align: right;
    }
  }
}
</style>